/**
 * @generated SignedSource<<28f38b254bfe5b7db21ffc3f5c08c6fe>>
 * @relayHash 13ae8934e04da59ec0a60a5d1726c98d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7b09c3842a64f05087319bb47294275ff34e28de93629240ef34276a5ff50483

import type { ConcreteRequest } from 'relay-runtime';
export type DeletePagesInput = {
  areChildrenIncluded?: boolean | null;
  excludedBranchRootPageIDs?: ReadonlyArray<AGG$Long | null> | null;
  isSelected?: boolean | null;
  pageID: AGG$Long;
};
export type ImportModalsDeletePagesActionMutation$variables = {
  input: ReadonlyArray<DeletePagesInput | null>;
};
export type ImportModalsDeletePagesActionMutation$data = {
  readonly deletePages: {
    readonly status: boolean;
    readonly taskId: string | null;
  } | null;
};
export type ImportModalsDeletePagesActionMutation = {
  response: ImportModalsDeletePagesActionMutation$data;
  variables: ImportModalsDeletePagesActionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeletePagesPayload",
    "kind": "LinkedField",
    "name": "deletePages",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "taskId"
      },
      {
        "kind": "ScalarField",
        "name": "status"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ImportModalsDeletePagesActionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImportModalsDeletePagesActionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "13ae8934e04da59ec0a60a5d1726c98d",
    "id": "7b09c3842a64f05087319bb47294275ff34e28de93629240ef34276a5ff50483",
    "metadata": {},
    "name": "ImportModalsDeletePagesActionMutation",
    "operationKind": "mutation",
    "text": "mutation ImportModalsDeletePagesActionMutation($input:[DeletePagesInput]!){deletePages(input:$input){taskId,status}}"
  }
};
})();

(node as any).hash = "7280a7bca4e27a7d55671ba8a0d07c5a";

export default node;
